// Shared attribute specs for newsletter block nodes.

export const generateId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }
  return `nl_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
}

// Tiptap node-attribute spec for the per-block stable id.
// Serialized to/from `data-id` on the DOM.
export const idAttributeSpec = {
  default: null,
  parseHTML: (el) => el.getAttribute("data-id"),
  renderHTML: (attrs) => (attrs.id ? { "data-id": attrs.id } : {}),
}

// PM node group strings are whitespace-separated. Membership checks must
// tokenize rather than string-compare, otherwise nodes like
// `"newsletterBlock newsletterText"` fail a `=== "newsletterBlock"` test.
export function nodeInGroup(nodeType, group) {
  const spec = (nodeType && nodeType.spec && nodeType.spec.group) || ""
  return spec.split(/\s+/).includes(group)
}
